import React from "react";
import styles from "../Styles/About.css";

const About = () => {
  return (
    <div className="Check-about">
      <p>
        IdeaKart is a site that gives u an idea about the book you want to buy.
        We offer a huge collection of books in diverse categories.
        <br />
        <br />
        We have a user friendly search engine and a quick delivery system. With
        this we even provide best discounts on our books you can write to us
        <br />
        for any idea or any help you need.
      </p>
      <p>
        IdeaKart is a site that gives u an idea about the book you want to buy.
        We offer a huge collection of books in diverse categories.
        <br />
        <br />
        We have a user friendly search engine and a quick delivery system. With
        this we even provide best discounts on our books you can write to us
        <br />
        for any idea or any help you need.
      </p>
    </div>
  );
};

export default About;